import {
  InputSelectControlField,
  Tooltip,
  useModalState,
  GreyGrey60,
  RedRed60,
  IconExclamationCircle,
  Box
} from '@sequencehq/core-components'
import { useSeatMetrics } from 'Seats/SeatMetric/useSeatMetrics'
import { CreateSeatTypeDrawer } from './CreateSeatTypeDrawer'
import Spinner from 'components/Loading'
import { match } from 'ts-pattern'

type SeatMetricId = string
interface Props
  extends Omit<
    React.ComponentProps<typeof InputSelectControlField>,
    | 'options'
    | 'onChange'
    | 'placeholder'
    | 'initialValue'
    | 'createLabel'
    | 'onCreate'
  > {
  onChange: (metricId: SeatMetricId) => void
  value?: SeatMetricId
  allowCreate?: boolean
}

export const SeatMetricSelect = ({
  value,
  onChange,
  allowCreate = true,
  ...selectControlProps
}: Props) => {
  const { isModalOpen, openModal, closeModal } = useModalState()
  const { metrics, loading, error } = useSeatMetrics()

  const trailingIcon = match({ loading, error })
    .with({ error: true }, () => (
      <Tooltip label="Error loading seat metrics">
        <Box paddingRight="4px" pointerEvents="initial">
          <IconExclamationCircle color={RedRed60} />
        </Box>
      </Tooltip>
    ))
    .with({ loading: true }, () => (
      <Tooltip label="Loading seat metrics...">
        <Box paddingRight="4px" pointerEvents="initial">
          <Spinner color={GreyGrey60} height="16px" width="16px" />
        </Box>
      </Tooltip>
    ))
    .otherwise(() => undefined)

  return (
    <>
      <InputSelectControlField
        options={metrics.map(item => ({
          value: item.id,
          label: item.label
        }))}
        onChange={onChange}
        placeholder="Select seat metric"
        initialValue={value}
        createLabel={allowCreate ? 'Create new seat metric' : undefined}
        trailingIcon={trailingIcon}
        onCreate={
          allowCreate
            ? () => {
                openModal()
              }
            : undefined
        }
        {...selectControlProps}
      />
      <CreateSeatTypeDrawer
        isOpen={isModalOpen}
        onClose={closeModal}
        onCreate={seatMetric => {
          onChange(seatMetric.id)
        }}
      />
    </>
  )
}
